module.exports = "mutation UpdateStore($data:UpdateStoreInput!){updateStore(data:$data){success}}"